import { getSessionToken } from '../auth-client';

export interface UploadedAttachment {
  id: string;
  fileName: string;
  mimeType: string;
  sizeBytes: number;
}

const MAX_FILE_BYTES = 10 * 1024 * 1024;

export const attachmentsApi = {
  async upload(file: File): Promise<UploadedAttachment> {
    if (file.size > MAX_FILE_BYTES) {
      throw new Error(`File "${file.name}" vượt 10MB.`);
    }
    const token = getSessionToken();
    const fd = new FormData();
    fd.append('file', file);
    const res = await fetch('/api/attachments', {
      method: 'POST',
      headers: token ? { Authorization: `Bearer ${token}` } : {},
      body: fd,
    });
    if (!res.ok) {
      const text = await res.text().catch(() => '');
      throw new Error(`Upload fail: ${res.status} ${text}`);
    }
    return (await res.json()) as UploadedAttachment;
  },

  async remove(id: string): Promise<void> {
    const token = getSessionToken();
    const res = await fetch(`/api/attachments/${id}`, {
      method: 'DELETE',
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
    if (!res.ok) throw new Error(`Delete fail: ${res.status}`);
  },

  downloadUrl(id: string): string {
    return `/api/attachments/${id}/download`;
  },

  /** Object URL có bearer để hiển thị preview ảnh trong các form. Caller cần revoke khi unmount. */
  async previewUrl(id: string): Promise<string> {
    const token = getSessionToken();
    const res = await fetch(`/api/attachments/${id}/download`, { headers: token ? { Authorization: `Bearer ${token}` } : {} });
    if (!res.ok) throw new Error(`Không tải được ảnh: ${res.status}`);
    return URL.createObjectURL(await res.blob());
  },

  /** Fetch với Bearer, mở blob trong tab mới. Tránh vấn đề anchor không gửi header. */
  async openInNewTab(id: string, fileName: string): Promise<void> {
    const token = getSessionToken();
    const res = await fetch(`/api/attachments/${id}/download`, {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
    if (!res.ok) throw new Error(`Không tải được: ${res.status}`);
    const blob = await res.blob();
    const url = URL.createObjectURL(blob);
    const w = window.open(url, '_blank');
    if (!w) {
      // popup blocked → force download
      const a = document.createElement('a');
      a.href = url;
      a.download = fileName;
      a.click();
    }
    // Revoke sau 60s (đủ để browser load)
    setTimeout(() => URL.revokeObjectURL(url), 60_000);
  },
};
